"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["as", "className", "header", "children", "href", "active"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CardTitle = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var as = props.as,
      className = props.className,
      header = props.header,
      children = props.children,
      href = props.href,
      active = props.active,
      otherProps = _objectWithoutProperties(props, _excluded);

  var classes = (0, _classnames["default"])(className, "pds-card-title", {
    "pds-typography-body-22 pds-typography-bold": header
  });
  var Component = as;
  return active ? /*#__PURE__*/_react["default"].createElement("a", {
    href: href
  }, /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: classes,
    ref: ref
  }, otherProps), children)) : /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: classes,
    ref: ref
  }, otherProps), children);
});

CardTitle.propTypes = {
  /**
   * Changes the HTML element of the CardTitle.
   * This is usually used to specify a different heading level.
   */
  as: _propTypes["default"].elementType,

  /** Extra classes for the CardTitle. */
  className: _propTypes["default"].string,

  /** The content of the CardSection. */
  children: _propTypes["default"].node,

  /** Where the callout card will navigate to. */
  href: _propTypes["default"].string,

  /** Styles the card as active. */
  active: _propTypes["default"].bool,

  /** Header forwarded from card */
  header: _propTypes["default"].oneOf(["header", "header-alt"])
};
CardTitle.defaultProps = {
  as: "h2"
};
CardTitle.displayName = "CardTitle";
var _default = CardTitle;
exports["default"] = _default;